<template>
  <BTooltip type="is-white" size="is-small" position="is-bottom" :multilined="true" :label="$t(label)">
    <IconHelp />
  </BTooltip>
</template>

<script>
import IconHelp from "@/assets/logos/coverage/icon-help.svg";
export default {
  components: {
    IconHelp,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.is-white::after {
  padding: 10px;
  border-radius: 2px;
  color: $gray-600 !important;
}

svg {
  margin-left: 5px;
}
</style>
